import { Button, Card, NavLink } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";
import { useState } from "react";
import { userServices } from "../../APIServices/UserData/userServices";
import { authServices } from "../../APIServices/UserData/authServices";

export default function GenerateSecretKey({
  setNextPage,
  name,
  email,
  setEmail,
  setName,
  setLoader,
  loader,
  cardAnim,
}) {
  const [showSecretKeyAlert, setShowSecretKeyAlert] = useState(false);

  const setUpSecretKey = async () => {
    setLoader(true);
    let userData = {
      email,
    };
    let data = await authServices.setUpSecretKey(userData);
    if (data?.statusCode === 200) {
      setShowSecretKeyAlert(true);
      setNextPage("setUpSecretKey");
      setEmail(data?.email);
      setName(data?.name);
    }
    setLoader(false);
  };

  function getTwoInitials() {
    if (!name) return "";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }
    const first = parts[0][0];
    const last = parts[parts.length - 1][0];
    return (first + last).toUpperCase();
  }

  return (
    <>
      <motion.div key="step5" {...cardAnim}>
        <Card
          className="border-0 shadow-lg"
          style={{ borderRadius: "18px", width: 420 }}
        >
          <Card.Body className="p-4">
            <div className="text-center mb-4">
              <h4 className="fw-bold mb-1">Your Secret Key 🔐</h4>
              <small className="text-muted">
                This key adds an extra layer of protection
              </small>
            </div>

            <div className="mb-3">
              <div className="hstack gap-2 mb-3">
                  <h6 className={`bg-primary-subtle p-3 rounded-1 fw-bold m-0`}>
                    {getTwoInitials(name)}
                  </h6>
                  <div>
                  <h6 className="m-0">{name}</h6>
                  <p className="small m-0 text-muted">{email}</p>
                </div>  
              </div>
            </div>
            {!showSecretKeyAlert ? (
              <div className="mb-4">
                <div
                  className="rounded-3 p-3 mb-4 bg-secondary-subtle"
                  style={{ fontSize: 13 }}
                >
                  <ul className="mb-0 ps-3">
                    <li>
                      The secret key is required when signing in on a new device
                    </li>
                    <li>Store the email in a secure location</li>
                    <li>Never share your secret key with anyone</li>
                    <li>If lost, your passwords cannot be recovered</li>
                  </ul>
                </div>
              </div>
            ) : (
              <div className="mb-4">
                 <div
                  className="rounded-3 p-3 mb-4 bg-secondary-subtle"
                  style={{ fontSize: 13 }}
                >
                  <ul className="mb-0 ps-3">
                    <li>
                      Secret Key Generated Successfully.
                    </li>
                    <li>Please keep it safe and secure.</li>
                  </ul>
                </div>
              </div>
            )}

            {!showSecretKeyAlert ? (
              <motion.div
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
              >
                <Button
                  disabled={loader}
                  onClick={setUpSecretKey}
                  className="w-100 py-2 fw-bold btn-gradient"
                >
                  Generate Secret Key <FaArrowRight />
                </Button>
              </motion.div>
            ) : (
              <motion.div
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
              >
                <NavLink to="/login" onClick={() => setNextPage("startLogin")}>
                  <Button className="w-100 py-2 fw-bold btn-gradient">
                    Continue to Login <FaArrowRight />
                  </Button>
                </NavLink>
              </motion.div>
            )}
          </Card.Body>
        </Card>
      </motion.div>
    </>
  );
}
